import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Stage, Layer, Circle, Text } from 'react-konva';
import PixelTemperature from "./PixelTemperature";
import ImagePreview from "./ImagePreview";
import "./MainImage.css";

import Loading from "./LoadingProgressBar"


const ImageItem =
    React.memo(function ImageItem({ imageNew, rois, isActiveTempImage, zoomValue, roiTextValueX, roiTextValueY, notes, selectedROI, indexSelectedROI   }) {

        return <ImagePreview imageNew={imageNew} rois={rois} isActiveTempImage={isActiveTempImage} zoomValue={zoomValue}
            roiTextValueX={roiTextValueX} roiTextValueY={roiTextValueY} notes={notes} selectedROI={selectedROI}
            indexSelectedROI={indexSelectedROI} />
    });

export default class MainImage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            stageWidth: 0,
            stageHeight: 0,
            stageOffsetX: 0,
            stageOffsetY: 0,
            pixelTemp: 0.0,
        };
    }

    componentDidMount() {
        this.setState({ isLoading: false});
        window.addEventListener("resize", this.checkSize);
        this.checkSize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.checkSize);
    }

    checkSize = () => {
        this.setState({
            stageWidth: this.container.offsetWidth,
            stageHeight: this.container.offsetHeight,
        });
    };

    getPosX = (offsetX) => {
        return offsetX - this.state.stageOffsetX;
    }

    getPosY = (offsetY) => {
        return offsetY - this.state.stageOffsetY;
    }

    handleMouseMove = e => {
        const { imBuffer, zoomValue, imageSize, isCelsius, isCelsiusImg} = this.props;

        let resetPorcentage = (1 / zoomValue).toFixed(2);
        let posX = Math.round(this.getPosX(e.evt.offsetX) * resetPorcentage);
        let posY = Math.round(this.getPosY(e.evt.offsetY) * resetPorcentage);

        const pTemp = this.convertTemp(Number((imBuffer[posY * imageSize[0].x + posX] - 273.15).toFixed(1)), isCelsius, isCelsiusImg);
        this.setState({ pixelTemp: pTemp });
    }

    convertTemp = (tempValue, isCelsius, isCelsiusImg) => {
        if (isCelsiusImg)
            return tempValue;
        else 
            return Number(tempValue * 1.8 + 32).toFixed(1);


    }

    handleDoubleClick = e => {
        const { isActiveTempImage, isExtendedImg, visualImage, calculateTemperatureValue,  } = this.props;

            if (isActiveTempImage && !isExtendedImg)
                visualImage();
            else
                calculateTemperatureValue();
   
    }

    handleDragEnd = e => {
        const { isDraggable } = this.props;
        isDraggable ? this.handleisDraggable(e) : this.handleisNotDraggable(e);
    }

    handleisNotDraggable = e => {
        e.target.position({ x: 0, y: 0 });
        this.setState({
            stageOffsetX: 0,
            stageOffsetY: 0,
        });
    };

    handleisDraggable = e => {

        const borderLimit = 100;

        const { zoomValue, imageSize } = this.props;

        if (e.target.x() < 0 && Math.abs(e.target.x()) > (imageSize[0].x * zoomValue) - borderLimit
            ||
            e.target.y() < 0 && Math.abs(e.target.y()) > (imageSize[0].y * zoomValue) - borderLimit
            ||
            e.target.x() > e.target.width() - borderLimit
            ||
            e.target.y() > e.target.height() - borderLimit

        ) {

            this.setState({
                stageOffsetX: 0,
                stageOffsetY: 0,
            });
            e.target.x(0);
            e.target.y(0);
        } else {
            this.setState({
                stageOffsetX: e.target.x(),
                stageOffsetY: e.target.y(),
            });
        }
    }



    roiTextValueX = (roi, zoomValue) => {
        return (this.state.stageWidth - 20 > roi.x) ? roi.x * zoomValue + roi.radius * 2 : roi.x * zoomValue - roi.radius * 2 - 6
    }

    roiTextValueY = (roi, zoomValue) => {
        return (this.state.stageHeight - 20 > roi.y) ? roi.y * zoomValue + roi.radius * 2 : roi.y * zoomValue - roi.radius * 2 - 6
    }

    render() {
        const { imageNew, isActiveTempImage, rois, zoomValue, notes, selectedROI, indexSelectedROI, languageSelected, isCelsius, isCelsiusImg } = this.props;

        //console.log(selectedROI);
        //console.log(indexSelectedROI);

        return (
            <div id="canvasDiv"
                style={{
                    width: "100%",
                    height: "100%",
                    border: "0px solid grey"
                }}
                ref={node => {
                    this.container = node;
                }}
            >
                <Loading />
                {isActiveTempImage && imageNew ? <PixelTemperature pixelTemp={this.state.pixelTemp} isCelsius={isCelsius} isCelsiusImg={isCelsiusImg}/> : null}
                { imageNew ?
                    <Stage id="container" className="container" width={this.state.stageWidth} height={window.innerHeight} draggable="true"
                        onDragEnd={this.handleDragEnd} >

                        <Layer onMouseMove={this.handleMouseMove} onDblClick={this.handleDoubleClick} >

                            <ImageItem imageNew={imageNew} rois={rois} isActiveTempImage={isActiveTempImage} zoomValue={zoomValue}
                                roiTextValueX={this.roiTextValueX} roiTextValueY={this.roiTextValueY} notes={notes} selectedROI={selectedROI}
                                indexSelectedROI={indexSelectedROI}  />


                        </Layer>
                    </Stage>
                : null}
            </div>
        );
    }
}

MainImage.propTypes = {

}
